//import { combineReducers } from 'redux';
import { createReducer, getType } from 'typesafe-actions';

import { spinnerStart, spinnerStop } from '../actions/spinner.actions';

const spinnerReducer = createReducer<number>(0)
  .handleType(getType(spinnerStart), (state, _action) => state += 1)
  .handleType(getType(spinnerStop), (state, _action) => state -= 1);

export default spinnerReducer;